import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Sgkc016aRequest, Sgkc016aResponse, SGKC016AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * スライド調整単価承認API使用サービス
 * @export
 * @class UsedSgkc016aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc016aService {
    /**
   * コンストラクタ
   * @param {SGKC016AService} sGKC016AService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc016aService
   */
    constructor(private sGKC016AService: SGKC016AService,
        private apiCommonService: ApiCommonService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * スライド調整単価承認API呼び出し
     * @param {Sgkc016aRequest} sgkc016aRequest
     * @return {Observable<Sgkc016aResponse>}
     * @memberof UsedSgkc016aService
     */
    approveSlideTankatable(sgkc016aRequest: Sgkc016aRequest): Observable<Sgkc016aResponse> {
        return this.sGKC016AService.kC10WSGKC016APost(<Sgkc016aRequest>this.apiCommonService.setRequestCommon(sgkc016aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC016A');
                    return throwError(err.message);
                })
            );
    }

}
